import Indexdasboard from "../../components/dashboard/IndexDashbord";
import React, { useEffect, useState } from "react";
import { Api_Token } from "../../util/Api";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Card,
  TablePagination,
  IconButton,
  Grid,
  CardContent,
  Divider,
  Pagination,
} from "@mui/material";
import ModelCaisse from "../../components/popup/ModelCaisse";
import DeleteConfirmation from "../../components/popup/deleteConfirmation";
import ButtonSimple from "../../components/Button/ButtonSimple";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import CustomAlert from "../../components/Alert/AlertCustomer";
import { useTranslation } from "react-i18next";
import LabelTypography from "../../components/Typography/LabelTypography";

function PageGestionMagasin() {
  return <Indexdasboard Children={<GestionMagasin />} />;
}

const GestionMagasin = () => {
  const [caisses, setCaisses] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const [openModal, setOpenModal] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    nomCaisse: "",
    adress: "",
  });
  const [caisseToDelete, setCaisseToDelete] = useState(null);
  const navigate = useNavigate();
  const [AlertEtat, setAlertEtat] = useState("inisial");
  const [AlertMessage, setAlertMessage] = useState("");
  const { t } = useTranslation();

  const fetchCaisses = async (currentPage, rowsPerPage) => {
    try {
      const response = await Api_Token.get(
        `caisses/getCaissePaginate?page=${
          currentPage + 1
        }&perPage=${rowsPerPage}`
      );
      setCaisses(response.data.data);
      setTotalCount(response.data.total);
    } catch (error) {
      console.error("Error fetching caisses:", error);
    }
  };

  // Confirm delete
  const handleDeleteCaisse = async () => {
    try {
      await Api_Token.delete(`/caisses/delete/${caisseToDelete.id}`);
      setAlertEtat("success");
      setAlertMessage(t("Caisse deleted successfully!"));
      fetchCaisses(page, rowsPerPage);
      handleCloseDeleteDialog();
    } catch (error) {
      setAlertEtat("error");
      setAlertMessage(t("Error deleting caisse: ") + error.message);
      console.error(t("Error deleting caisse:"), error);
    }
  };

  const handleSubmit = async () => {
    try {
      if (formData.id) {
        await Api_Token.put(`caisses/update/${formData.id}`, formData);
        setAlertEtat("success");
        setAlertMessage(t("Caisse updated successfully!"));
      } else {
        await Api_Token.post("caisses/newCaisse", formData);
        setAlertEtat("success");
        setAlertMessage(t("Caisse created successfully!"));
      }
      fetchCaisses(page, rowsPerPage);
      handleCloseModal();
    } catch (error) {
      setAlertEtat("error");
      setAlertMessage(t("Error submitting form: ") + error.message);
      console.error("Error submitting form:", error);
    }
  };

  useEffect(() => {
    fetchCaisses(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleOpenModal = (
    caisse = { id: null, nomCaisse: "", adress: "" }
  ) => {
    setFormData(caisse);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenDeleteDialog = (caisse) => {
    setCaisseToDelete(caisse);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setCaisseToDelete(null);
  };

  return (
    <Box>
      <TitreGraphik>
        <span onClick={() => navigate(-1)}>⬅</span>
        {t("gestion magasin")}
      </TitreGraphik>
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <Card sx={{ padding: "2%", width: "100%" }}>
          <ButtonSimple variant="contained" onClick={() => handleOpenModal()}>
            {t("Add New Caisse")}
          </ButtonSimple>

          <TableContainer sx={{ marginTop: "20px" }}>
            <Table sx={{ minWidth: 650 }} aria-label="caisses table">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="center">{t("ID")}</StyledTableCell>
                  <StyledTableCell align="center">
                    {t("Nom Caisse")}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t("Adress")}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {t("Actions")}
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {caisses.map((caisse) => (
                  <StyledTableRow key={caisse.id}>
                    <StyledTableCell align="center">
                      <Link
                        to={`/CaisseJourney/${caisse.id}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        #{caisse.id}
                      </Link>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {caisse.nomCaisse}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {caisse.adress}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <IconButton
                        variant="outlined"
                        onClick={() => handleOpenModal(caisse)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        variant="outlined"
                        color="error"
                        onClick={() => handleOpenDeleteDialog(caisse)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>{" "}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Card>
      </Box>

      <Box sx={{ display: { xs: "flex", md: "none" } }}>
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {" "}
              <ButtonSimple
                variant="contained"
                onClick={() => handleOpenModal()}
                fullwidth
              >
                {t("Add New Caisse")}
              </ButtonSimple>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {" "}
                {caisses.map((caisse) => (
                  <Grid item xs={12} sm={6} md={4} key={caisse.id}>
                    <Card
                      variant="outlined"
                      sx={{ maxWidth: 345, width: "95%", margin: "auto" }}
                    >
                      <CardContent>
                        <LabelTypography textAlign="center">
                          {t("ID")} :
                          <Link
                            to={`/CaisseJourney/${caisse.id}`}
                            style={{ textDecoration: "none", color: "inherit" }}
                          >
                            #{caisse.id}
                          </Link>
                        </LabelTypography>
                        <Divider sx={{ margin: "10px 0" }} />

                        <LabelTypography color="text.primary">
                          {t("Nom Caisse")} : {caisse.nomCaisse}
                        </LabelTypography>
                        <LabelTypography color="text.primary">
                          {t("Adress")} : {caisse.adress}
                        </LabelTypography>
                        <Divider sx={{ margin: "10px 0" }} />

                        <Box display="flex" justifyContent="center">
                          <IconButton
                            variant="outlined"
                            onClick={() => handleOpenModal(caisse)}
                          >
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            variant="outlined"
                            color="error"
                            onClick={() => handleOpenDeleteDialog(caisse)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      marginTop: "3%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination
                      count={Math.ceil(totalCount / rowsPerPage)}
                      onChange={(event, newPage) => {
                        setPage(newPage - 1); // Adjust for 0-based indexing
                      }}
                      variant="outlined"
                      color="primary"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <ModelCaisse
        open={openModal}
        onClose={handleCloseModal}
        formData={formData}
        submit={handleSubmit}
        handleInputChange={handleInputChange}
      />
      <DeleteConfirmation
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        message={t(
          "Are you sure you want to delete the cash register {{nomCaisse}}?",
          { nomCaisse: caisseToDelete?.nomCaisse }
        )}
        confirme={handleDeleteCaisse}
      />
      <CustomAlert
        open={AlertEtat !== "inisial"}
        onClose={() => {
          setAlertEtat("inisial");
        }}
        etat={AlertEtat}
        message={AlertMessage}
      />
    </Box>
  );
};

export default PageGestionMagasin;
